/**
 * @file        src/api/corporateRequests.js
 * @description Admin Corporate Registration Requests API calls
 *              (/api/corporate-requests) — the approval queue the storefront's
 *              "Register your company" form files into (migration 049,
 *              admin_backend). List is read by Account Management/Customer
 *              Management; approve/reject require Account Management.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (corporate registration approval flow).
 */
import { get, post } from './client';

export const listCorporateRequests = (params) => get('/corporate-requests', { params });
export const approveCorporateRequest = (id) => post(`/corporate-requests/${id}/approve`);
export const rejectCorporateRequest = (id, reason) => post(`/corporate-requests/${id}/reject`, { reason });
